import type {
  CreatePublicSupportTicketResponseDto,
  CreateSupportTicketResponseDto,
  SupportTicketAttachmentDto,
  SupportTicketDetailDto,
  SupportTicketRowDto,
  SupportTicketsListDto,
  TicketCategoryDto,
} from '../contracts/supportTicketContracts'
import type {
  SupportTicket,
  SupportTicketAttachment,
  TicketCategory,
} from '../../types/supportTypes'

// The server already returns categories in display order and tickets newest
// first; the parser renames to view models and drops wire-only fields.
export function parseTicketCategories(dtos: TicketCategoryDto[]): TicketCategory[] {
  return dtos.map((dto) => ({ id: dto.id, code: dto.code, title: dto.title }))
}

function parseSupportTicket(dto: SupportTicketRowDto): SupportTicket {
  return {
    id: dto.id,
    referenceCode: dto.referenceCode,
    subject: dto.subject,
    description: dto.description,
    categoryTitle: dto.categoryTitle,
    status: dto.status,
    createdAt: dto.createdAt,
  }
}

export function parseSupportTickets(dto: SupportTicketsListDto): SupportTicket[] {
  return dto.rows.map(parseSupportTicket)
}

// Both create calls resolve to the reference the seller quotes to support.
export function parseCreatedTicketReference(
  dto: CreateSupportTicketResponseDto | CreatePublicSupportTicketResponseDto,
): string {
  return dto.referenceCode
}

const IMAGE_MIME_PREFIX = 'image/'

function parseSupportTicketAttachment(dto: SupportTicketAttachmentDto): SupportTicketAttachment {
  return {
    id: dto.id,
    fileName: dto.fileName,
    sizeBytes: dto.fileSizeBytes,
    url: dto.url,
    isImage: dto.mimeType.startsWith(IMAGE_MIME_PREFIX),
  }
}

// The drawer already shows the ticket from its list row; the detail call is
// only for what the row lacks — the attachments.
export function parseSupportTicketAttachments(
  dto: SupportTicketDetailDto,
): SupportTicketAttachment[] {
  return dto.attachments.map(parseSupportTicketAttachment)
}
